import Adventure from './adventure';

export default Adventure;